import React from "react";
import { connect } from "react-redux";
import { validarPass } from "../gnp-login/services.act";
import { callService, goTo } from "../tools";
import SeguridadForm from "./seguridad.frm";
import SeguridadFormMovil from "./seguridad-movil.frm";
import axios from 'axios';
import { movil } from '../app-movil';
import ModalSintillo from '../mensajes-tooltips/mensajes-tooltips.cmpt';
import { authentication } from "../app-database";
import { servicios } from "./../properties";
import firebase from 'firebase';
import BtnAyuda from "../gnp-registro/btn-ayuda.cmpt"
import ModalOpcionesAyuda from "../../src/modal-ayuda/modal-opciones-ayuda.cmpt";

const mensajeItim = "Ocurrió un error inesperado, comunícate a la línea GNP 55 5227 9000 para más información.";
const obtenerHash = "registro.obtenerurlregistro";
const aplication = 'application/json';
const validacion = "VALIDACIÓN";

const mapState = (state) => {
	return {
		hashOne: state.registro.hashOne,
		hashTwo: state.registro.hashTwo,
		hashThree: state.registro.hashThree,
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		},
		alerta: (sTitulo, sMensaje, fnCerrar) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_ACTION_SHOW", "titulo": sTitulo, "mensaje": sMensaje, "accion": fnCerrar });
		},
		setPaso: (paso) => {
			dispatch({ "type": "CONTRATOS_PASO", "paso": paso });
		},
		registrarDatos(sPassword, sPregunta1, sRespuesta1, sPregunta2, sRespuesta2) {
			dispatch({
				"type": "REGISTRO_SEGURIDAD",
				"password": sPassword,
				"pregunta1": sPregunta1,
				"respuesta1": sRespuesta1,
				"pregunta2": sPregunta2,
				"respuesta2": sRespuesta2
			});
		},
		tagManager: (oDataTagManager) => {
			dispatch(oDataTagManager);
		},
		eventoCorrectos: (dispositivo) => {
			dispatch({ "type": "EVENT_LOGIN_BIENVENIDO_CORRECTOS", "flujo": "login", "dispositivo": dispositivo });
		},
		loginSecreto: (nombre) => {
			dispatch({ "type": "LOGIN_SET_SECRETO", "secreto": nombre });
		},
		loginserCliente: (clienteUnico) => {
			dispatch({ "type": "LOGIN_SET_CVECLIENTE", "cveCliente": clienteUnico });
		},
		loginIniciarSesionCorrecto: (dispositivo) => {
			dispatch({ "type": "EVENT_LOGIN_INICIARSESION_CORRECTOS", "flujo": "login", "dispositivo": dispositivo });

		}
	};
};

class Seguridad extends React.Component {
	hashTwoEmail = "";
	password = "";
	URLBienvenido = "login.bienvenido";
	nombre = "";
	state = {
		nombreCompleto: "",
		showTooltip: false,
		mensaje: "",
		type: "",
		titulo: "",
	}

	muestraTooltip = (show, type?, titulo?, mensaje?) => {
		setTimeout(() => {
			this.setState({ showTooltip: show, type: type, titulo: titulo, mensaje: mensaje });
		}, 300);
	}

	cierraTooltip = e => {
		this.setState({
			showTooltip: !this.state.showTooltip
		});
	}

	close = () => {
		if (this.props.dispositivo === 'app') {
			const mensaje = { "return": "home" };
			movil("", mensaje);
		} else {
			goTo("login");
		}
	}

	componentWillMount = () => {
		if (this.props.dispositivo === 'web') {
			new callService({
				service: 'registro.obtenerNombreMedios',
				"secure": true,
				data: { cveCliente: localStorage.getItem('cveClienteUnico') }
			}).execute().then(body => {
				if (body.consultarClienteResponse.nombre !== '') {
					var splitNombre = body.consultarClienteResponse.nombre.split(" ");
					this.setState({ nombreCompleto: splitNombre[0] + " " + body.consultarClienteResponse.apellidoPaterno })
					console.log(this.state.nombreCompleto);
				}
			}).catch(error => {
				console.log('error nombre', error);
			});
		} else {
			const $this = this;
			this.props.loader(true);
			new callService({
				service: "registro.datosSeguridad",
				secure: true,
				data: {
					hashOne: this.props.hashOne,
					hashTwo: this.props.hashTwo
				}
			}).execute().then((respuesta) => {
				console.log("Respuesta", respuesta);
				$this.props.loader(false);
			}).catch((error) => {
				console.log("Error", error);
				$this.props.loader(false);
				$this.props.alerta("ERROR", error.message.mensaje, $this.close);
			});
		}
	}

	submit = (data) => {
		if (data.password === data.confpassword) {
			this.submit2(data);
		} else {
			console.log("Las contraseñas no coinciden");
		}
	}

	submit2 = (data) => {
		if (this.props.dispositivo === 'web') {
			this.password = data.password;
			this.props.loader(true);
			let emails = '';
			new callService({
				service: obtenerHash,
				secure: false,
				data: { valor: this.props.hashTwo, encripta: true }
			}).execute().then(datosPass => {
				emails = datosPass.hash

				console.log("emails", emails);

				if (localStorage.getItem('actualizo') !== null) {
					this.hashTwoEmail = "";
				} else {
					this.hashTwoEmail = this.props.hashTwo;
				}

				new callService({
					service: "registro.datosContratos",
					secure: true,
					data: {
						hashOne: this.props.hashOne,
						hashTwo: this.hashTwoEmail,
						password: data.password,
						pregunta1: "PSC15",
						pregunta2: "PSC04",
						respuesta1: "negro",
						respuesta2: "nissan",
						mediosElectronicos: true,
						email: emails
					}
				}).execute().then((respuesta) => {
					console.log(respuesta);
					this.validarUsuarioCompleto(emails, true);
				}).catch((error) => {
					console.log("Error service datosContratos", error)
					this.props.loader(false);

					if (error.message.codigoError.includes("ITIM")) {
						this.muestraTooltip(true, 'error', validacion, mensajeItim);
					} else if (error.message.codigoError === 'eCl00026') {
						this.muestraTooltip(true, 'error', 'ERROR', "Lo sentimos, por su seguridad no puede introducir contraseñas anteriores.");
					}
					else {
						this.validarUsuarioCompleto(emails, false);
					}

					this.props.tagManager({
						"type": "EVENT_REGISTRO_SIG_INCORRECTOS_SEGURIDAD", "dispositivo": this.props.dispositivo, "ramo": localStorage.getItem("ramo")
					});
					setTimeout(() => {
						this.muestraTooltip(false);
					}, 4000);
				})

			}).catch(error => {
				console.log("error hash Pass submit", error);
			});
			return 1;
		} else {
			return new Promise(resolve => {
				this.props.tagManager({
					"type": "EVENT_REGISTRO_SIG_CORRECTOS_SEGURIDAD", "dispositivo": this.props.dispositivo, "ramo": localStorage.getItem("ramo")
				});
				this.props.registrarDatos(data.password, data.pregunta1, data.respuesta1, data.pregunta2, data.respuesta2);
				this.props.setPaso(2);
				resolve();
			});
		}
	}

	exitoDatosContratos = (email) => {
		this.props.loader(false);
		this.registroInconcluso(email);
		this.registroInconclusoPoliza();
		this.registroBorradoUsuarios();
		this.props.tagManager({
			"type": "EVENT_REGISTRO_SIG_CORRECTOS_SEGURIDAD", "dispositivo": this.props.dispositivo, "ramo": localStorage.getItem("ramo")
		});
		$('#modal-final').modal({ backdrop: 'static', keyboard: false });
	}

	validarUsuarioCompleto = (email, exito) => {
		axios({
			method: 'POST',
			url: servicios.utilerias.actualizaNodoRestablecer,
			headers: {
				'Content-Type': aplication,
				'Access-Control-Allow-Origin': '*',
				"valor": email,
				"encripta": true
			}
		}).then(response => {
			const encriptar = true;
			new callService({
				"service": this.URLBienvenido,
				"secure": true,
				"data": { "correo": response.data.hash, "encriptar": encriptar }
			}).execute().then(body => {
				if (body.hasOwnProperty("consultarClienteResponse")) {
					this.nombre = body.consultarClienteResponse.nombre;
					this.exitoDatosContratos(email);
				} else {
					if (exito) {
						console.log('ocurrio un error');
					} else {
						this.muestraTooltip(true, 'error', 'ERROR', "Error Disculpe, ocurrió un error en el servicio, favor de realizar su registro nuevamente.");
					}
				}
			}).catch(error => {
				if (exito) {
					console.log('error', error);
				} else if (error.message.codigoError.includes("ITIM")) {
					this.muestraTooltip(true, 'error', validacion, mensajeItim);
				} else {
					this.muestraTooltip(true, 'error', 'ERROR', "Error Disculpe, ocurrió un error en el servicio, favor de realizar su registro nuevamente.");
				}
				this.props.loader(false);
			})
		}).catch(error => {
			console.log("error passx", error);
		});
	}

	registroInconcluso = (email) => {
		const hashOne = this.props.hashOne;
		const bandera = true;
		new callService({
			service: "registro.incConcluirRegistro",
			secure: true,
			data: {
				correo: email.toLowerCase(),
				banConcluirReg: bandera,
				path: hashOne
			}
		}).execute().then((respuesta) => {
			console.log("Respuesta incConcluirRegistro", respuesta);

		}).catch((error) => {
			console.log("Error incConcluirRegistro", error);
		});
	}

	registroInconclusoPoliza = () => {
		const hashOne = this.props.hashOne;
		const bandera = true;
		new callService({
			service: "registro.incConluirRegistroPoliza",
			secure: true,
			data: {
				poliza: localStorage.getItem('poliza'),
				certificado: localStorage.getItem('certificado'),
				sistema: localStorage.getItem('sistema'),
				banConcluirReg: bandera,
				path: hashOne
			}
		}).execute().then((respuesta) => {
			console.log("Respuesta incConluirRegistroPoliza ", respuesta);

		}).catch((error) => {
			console.log("Error incConluirRegistroPoliza ", error);
		});
	}

	registroBorradoUsuarios = () => {

		new callService({
			service: "registro.datosBorradoUsuarios",
			secure: true,
			data: {
				ramaClave: localStorage.getItem('cveClienteUnico'),
				completo: true,
				confidencialidad: true,
				contrato: true,
				email: localStorage.getItem('email')
			}
		}).execute().then((respuesta) => {
			console.log("Respuesta datosBorradoUsuarios ", respuesta);

		}).catch((error) => {
			console.log("Error datosBorradoUsuarios ", error);
		});
	}

	irLogin = () => {
		const correo = localStorage.getItem("email");

		localStorage.setItem("correoG", correo);

		this.props.loader(true);
		let emailLogin = '';
		console.log(this.props.hashTwo);
		new callService({
			service: obtenerHash,
			secure: false,
			data: { valor: this.props.hashTwo, encripta: true }
		}).execute().then(datosPass => {
			console.log("datos:", datosPass);
			emailLogin = datosPass.hash

			axios({
				method: 'POST',
				url: servicios.utilerias.actualizaNodoRestablecer,
				headers: {
					'Content-Type': aplication,
					'Access-Control-Allow-Origin': '*',
					"valor": emailLogin,
					"encripta": true
				}
			}).then(response => {
				const encriptar = true;
				new callService({
					"service": this.URLBienvenido,
					"secure": true,
					"data": { "correo": response.data.hash, "encriptar": encriptar }
				}).execute().then(body => {
					console.log("body:", body);
					if (body.hasOwnProperty("consultarClienteResponse")) {
						firebase.database().ref("portales/portalReingenieria").once("value").then(oValue => {
							var data = oValue.val();
							if (!data) {
								this.props.loginSecreto(body.consultarClienteResponse.nombre);
								this.props.loginserCliente(localStorage.getItem('cveClienteUnico'));
								this.props.loginIniciarSesionCorrecto(this.props.dispositivo);
								this.mandaPassword(localStorage.getItem('cveClienteUnico'), emailLogin, this.password);
							} else {
								new callService({
									service: obtenerHash,
									secure: false,
									data: { valor: this.password, encripta: false }
								}).execute().then(datosPass => {
									console.log(this.password, datosPass);
									const urlN = servicios.dominioReingenieria + "?correo=" + this.props.hashTwo + "&pass=" + datosPass.hash;
									console.log(urlN);
									window.location.assign(urlN);
								}).catch(error => {
									console.log("error hash Pass", error);
								})
							}
						})
					} else {
						console.log('error');
						goTo("login");
					}
				}).catch(error => {
					console.log(error);
					goTo("login");
					this.props.loader(false);
				})
			}).catch(error => {
				console.log("error", error);
			});

		}).catch(error => {
			console.log("error hash Passss", error);
		})
	}

	mandaPassword = (cliente, correo, pass) => {
		const $this = this;
		validarPass(cliente, correo, pass).then((response) => response.json()).then((responseJson) => {
			if (responseJson.hasOwnProperty("jwt")) {
				authentication.signInWithCustomToken(responseJson.jwt).then(function (result) {
					$this.props.eventoCorrectos($this.props.dispositivo);
					localStorage.setItem("refreshToken", responseJson.refreshtoken);

					new callService({
						service: obtenerHash,
						secure: false,
						data: { valor: pass, encripta: false }
					}).execute().then(datosPass => {
						const urlN = servicios.dominioReingenieria + "?correo=" + this.props.hashTwo + "&pass=" + datosPass.hash;

						window.location.assign(urlN);

					}).catch(error => {
						console.log("error hash Pass", error);
					})

					this.props.tagManager({
						"type": "EVENT_LOGIN_INICIAR_SESION", "dispositivo": this.props.dispositivo, "ramo": localStorage.getItem("ramo")
					});
					$this.props.loader(false);
				}).catch(function (error) {
					console.log("signInWithCustomToken", error);
					goTo("login");
					$this.props.loader(false);
				});
			} else {
				console.log('error');
				goTo("login");
				$this.props.loader(false);
			}
		})
	}

	cancelar = () => {

		localStorage.removeItem("aceptarAviso");
		localStorage.removeItem("mediosElectronicos");
		firebase.database().ref("portales/portalReingenieria").once("value").then(oValue => {
			console.log(oValue);
			var data = oValue.val();
			if (!data) {
				goTo("login");
			} else {
				window.location.assign(servicios.dominioReingenieria);
			}
		})
	}

	render() {
		return (
			<div>
				{this.props.dispositivo === "web" ?
					<div>
						<div className="txt-center">
							<div id="title-Registro">
								<span className="material-icons bi bi-arrow-left" style={{ float: "left", cursor: "pointer", marginTop: "20px" }} onClick={this.cancelar}>
									arrow_back
								</span>
								<h3 id="txt-Registro">Registro</h3>
								<br />
								<hr className="label-hr" />
							</div>
						</div>
						<SeguridadForm onSubmit={this.submit} />
					</div> :
					<SeguridadFormMovil onSubmit={this.submit} />}

				<div className='modal fade' id='modal-final' tabIndex='-1' role='dialog' aria-labelledby='modal-final'
					style={{ marginLeft: '19%' }}>
					<div className='modal-dialog modal-dialog-2' role="document">
						<div className='modal-content modal-content-final modal-content-final-2'>
							<div className='modal-header modal-header-final-2' >
								<span className='icon-circle-dove icono-modal-final icono-modal-final-2' ></span>
								<h4 className='modalfin-title' >
									¡Bienvenido {this.nombre}!
								</h4>
							</div>
							<div className='modal-body-final modal-body-final-2'>
								<p>Tu información ha sido guardada satisfactoriamente</p>
								<p>De ahora en adelante podrás iniciar sesión ingresando tu correo y contraseña.
								</p>
							</div>
							<div className='modal-footer' style={{ marginTop: '-5px', padding: '0px' }}>
								<button type='button' className='btn-orange-modal-final'
									onClick={this.irLogin} data-dismiss='modal'>Aceptar</button>
							</div>
						</div>
					</div>
				</div>
				{<ModalOpcionesAyuda></ModalOpcionesAyuda>}
				{<BtnAyuda></BtnAyuda>}
				<ModalSintillo onClose={this.cierraTooltip} titulo={this.state.titulo}
					show={this.state.showTooltip} type={this.state.type} mensaje={this.state.mensaje}>
				</ModalSintillo>
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(Seguridad);


// WEBPACK FOOTER //
// ./src/gnp-registro-seguridad/seguridad.cmpt.js